import { render } from "./manageList.vue?vue&type=template&id=23e35ccb&scoped=true"
import script from "./manageList.vue?vue&type=script&lang=js"
export * from "./manageList.vue?vue&type=script&lang=js"

import "./manageList.vue?vue&type=style&index=0&id=23e35ccb&lang=scss&scoped=true"
import "./manageList.vue?vue&type=style&index=1&id=23e35ccb&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e35ccb"]])

export default __exports__